import { render, staticRenderFns } from "./MonitoringKuliDetailModal.vue?vue&type=template&id=d32b705e&scoped=true&"
import script from "./MonitoringKuliDetailModal.vue?vue&type=script&lang=js&"
export * from "./MonitoringKuliDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringKuliDetailModal.vue?vue&type=style&index=0&id=d32b705e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32b705e",
  null
  
)

export default component.exports